import React from 'react';

import Diploma from 'components/Diploma';
import { useSettings } from 'hooks/useSettings';
import { useUserInfo } from 'hooks/useUserInfo';

const DiplomaView = () => {
  const { appId, loaded: settingsLoaded } = useSettings();
  const { loaded: userLoaded, user } = useUserInfo();

  const { first_name: firstName = '', last_name: lastName = '', email = '' } = user || {};
  const diplomaAppId = Number(appId) || -1;
  const hasDiplomaDetails = settingsLoaded && userLoaded && firstName && lastName && email;

  return (
    <div className="contentContainer diplomaView" data-testid="diploma-view">
      {hasDiplomaDetails && <Diploma appId={diplomaAppId} firstName={firstName} lastName={lastName} email={email} />}
    </div>
  );
};

export default DiplomaView;
